import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicFutureEvents {
  constructor(section) {
    this.el = section.el;
    this.splide = null;
    this._init();
  }

  _init() {
    this.splide = initCarousel(
      this.el,
      {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        gap: '1rem',
        arrows: true,
        pagination: true,
        padding: {
          right: '10%',
        },
        mediaQuery: 'min',
        breakpoints: {
          [unitlessBreakpoints.sm]: {
            padding: { right: '25%' },
          },
          [unitlessBreakpoints.md]: {
            perPage: 2,
            padding: { right: '5%' },
          },
          [unitlessBreakpoints.lg]: {
            padding: { right: '15%' },
          },
          [unitlessBreakpoints.xl]: {
            perPage: 3,
            padding: 0,
          },
        },
      },
      true,
    );
  }

  onSectionUnload() {
    if (this.splide) {
      this.splide.destroy();
      this.splide = null;
    }
  }
}
